// BigCards.jsx
import React from 'react';
import CardLarge from '../tables/shared/CardLarge/CardLarge';
import './big-cards.css';

const BigCards = ({ selectedHand }) => {
  if (!selectedHand?.card1 || !selectedHand?.card2) return null;

  const SUIT_MAP = {
    'h': 'hearts',
    'd': 'diamonds',
    'c': 'clubs',
    's': 'spades'
  };

  const getCardText = (value) => {
    const faceCards = {
      't': '10',
      'j': 'J',
      'q': 'Q',
      'k': 'K',
      'a': 'A'
    };
    
    // Convert the value to lowercase for consistent comparison
    const lowercaseValue = value.toLowerCase();
    
    // If it's a face card, return the mapped value
    if (faceCards[lowercaseValue]) {
      return faceCards[lowercaseValue];
    }
    
    // Otherwise, return the numeric value
    return value;
  };

  const getCardProps = (card) => {
    return {
      text: getCardText(card[0]),
      property1: SUIT_MAP[card[1].toLowerCase()] || 'blank',
      className: "card"
    };
  };

  return (
    <div className="big-cards-container">
      <div className="big-card-wrapper">
        <CardLarge {...getCardProps(selectedHand.card1)} />
      </div>
      <div className="big-card-wrapper overlapped">
        <CardLarge {...getCardProps(selectedHand.card2)} />
      </div>
    </div>
  );
};

export default BigCards;